import getRollbarInstance from './getRollbarInstance';

type LoadScriptOptions = {
  onLoad?: () => void;
  onError?: () => void;
  async?: boolean;
  crossOrigin?: 'anonymous' | 'use-credentials' | null;
};

function loadScript(
  source: string,
  options: LoadScriptOptions = {},
): Promise<void> {
  const {
    async = true,
    crossOrigin = null,
    onError,
    onLoad,
  } = options;

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = source;
    script.crossOrigin = crossOrigin;
    script.async = async;

    script.onerror = (): void => {
      if (onError) onError();
      reject();
      getRollbarInstance().error(`SDK: Loading of script [${source}] failed.`);
    };

    script.onload = (): void => {
      if (onLoad) {
        onLoad();
      }
      resolve();
    };

    document.head.appendChild(script);
  });
}

export default loadScript;
